import React, { Component } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import DragListItem from './drag-list-item';

const styles = {
  container: {
    maxHeight: 440,
    overflow: 'auto',
    background: '#efefef',
    border: 'solid lightgray 1px',
  },
  list: {
    width: 250,
    padding: 5,
  },
};

class DragListContainer extends Component {
  constructor(props) {
    super(props);

    this.onDragEnd = this.onDragEnd.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  onDragEnd(result) {
    const { locations, setLocations } = this.props;
    if (!result.destination) {
      return;
    }
    const newLocations = this.reorder(locations, result.source.index, result.destination.index);
    setLocations([...newLocations]);
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  }

  handleRemove(index) {
    const {
      locations, setLocations, changedLocations, setChangedLocations,
    } = this.props;
    const id = locations[index]._id;
    if (locations.length === 1 && index === 0) {
      setLocations([]);
    } else if (index > -1) {
      locations.splice(index, 1);
      setLocations([...locations]);
    }

    const potentialIndex = changedLocations.indexOf(id);
    if (potentialIndex !== -1) {
      changedLocations.splice(potentialIndex, 1);
      setChangedLocations([...changedLocations]);
    }
  }

  render() {
    const { locations } = this.props;

    return (
      <div style={styles.container}>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable key={1} droppableId="droppable">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={styles.list}
              >
                {locations.map((location, index) => (
                  <div key={location._id}>
                    <DragListItem
                      location={location}
                      handleRemove={this.handleRemove}
                      index={index}
                    />
                  </div>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    );
  }
}

export default DragListContainer;
